'use client';

import type { ReactNode } from 'react';

import ContentCarousel, { type ContentCarouselProps } from '../../../components/ContentCarousel.js';

export type {
  ContentCarouselProps as BannerCarouselClientProps,
  ContentCarouselSlide as BannerCarouselSlide,
} from '../../../components/ContentCarousel.js';

export default function BannerCarouselClient(props: ContentCarouselProps): ReactNode {
  return <ContentCarousel {...props} />;
}
